<template>
	<!-- Shape of pages/account.vue: blue tab bar, (desktop) hero, centered content card. -->
	<div aria-hidden="true">
		<!-- Blue tab bar (keeps the real bar colour so there's no flash) -->
		<div class="w-full md:h-14 bg-ncfic-blue-400 dark:bg-gray-700 border-b-2 border-ncfic-blue-500 dark:border-gray-600 flex items-center justify-center py-3 md:py-0">
			<div class="flex items-center space-x-6 md:space-x-8">
				<Skeleton v-for="n in 4" :key="n" class="h-4 w-16 md:w-20" />
			</div>
		</div>

		<!-- Hero (desktop only, mirrors layout/hero.vue being hidden on mobile) -->
		<div class="hidden sm:flex flex-col items-center py-12">
			<Skeleton class="h-12 w-48" />
		</div>

		<!-- Content -->
		<div class="w-full flex flex-col justify-start items-center mb-16">
			<div class="w-full max-w-7xl flex flex-col items-center p-4 md:p-8 space-y-4">
				<Skeleton class="w-full max-w-md h-7" />
				<Skeleton rounded="rounded-xl" class="w-full max-w-md h-40" />
				<Skeleton rounded="rounded-xl" class="w-full max-w-md h-24" />
			</div>
		</div>
	</div>
</template>

<script>
import Skeleton from '../skeleton.vue'

export default {
	name: 'AccountSkeleton',
	components: { Skeleton },
}
</script>
